// extracted by mini-css-extract-plugin
export default {"RecoverRemovedItems__container":"styles_RecoverRemovedItems__container__GgvYC","OrderItems__container":"styles_OrderItems__container__ZrCKn"};